import { GlobalService } from './global.service';
import { InfoEsitoSDIObject } from './../models/helper.model';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SDIResponseObject } from '../models/helper.model';
import { TwoCLogDTO } from '../models/twoCLog.model';
import { SDIUpdateDTO } from '../models/document.model';
import { UpdateDocumentResult } from '../models/document.model';
import { SDIInvoiceStateCountersDTO } from '../models/invoicestatecounters.model';

@Injectable({
  providedIn: 'root'
})

export class SDIService {

  constructor(private http: HttpClient) {
  }

  getUrlPortaleFe(FK_Company: number): Promise<SDIResponseObject> {
    return this.http.get<SDIResponseObject>(environment.apiFullUrl + "/SDI/GetUrlAccessoPortale/" + FK_Company).toPromise();
  }

  sendXmlInvoicesToSDI(FK_Company: number, selectedDocumentsID: Array<number>): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'blob'
    }
    return this.http.post<any>(environment.apiFullUrl + "/paDT/SendUBL/", selectedDocumentsID, HTTPOptions).toPromise();
  }

  getTwoLogsByDocumentID(documentID: number): Promise<Array<TwoCLogDTO>> {
    return this.http.get<Array<TwoCLogDTO>>(environment.apiFullUrl + "/paDT/GetTwoLogsByDocumentID/" + documentID).toPromise();
  }

  updateSDIResult(FK_Company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/SDI/UpdateSDIResult/" + FK_Company).toPromise();
  }

  getInfoEsitoSDI(FK_Company: number, idSdi: number): Promise<InfoEsitoSDIObject> {
    return this.http.get<InfoEsitoSDIObject>(environment.apiFullUrl + "/SDI/GetInfoEsitoByIdSDI/" + FK_Company + '/' + idSdi).toPromise();
  }

  updateSDI(dto: SDIUpdateDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/SDI/UpdateSDI', dto).toPromise();
  }

  updateDocumentSDI(updateDocumentResult: UpdateDocumentResult): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/SDI/UpdateDocumentSDI/" + updateDocumentResult + "/" + GlobalService.getUsedCompany()).toPromise();
  }

  getInvoiceStateCounters(FK_Company: number, datastart: Date, dataend: Date): Promise<SDIInvoiceStateCountersDTO[]> {
     return this.http.get<SDIInvoiceStateCountersDTO[]>(environment.apiFullUrl + "/SDI/GetInvoiceStateCounters/" + FK_Company + "/" + datastart.toDateString() + "/" + dataend.toDateString()).toPromise();
  }

  // updateCounterInvoices(FK_Company: number): Promise<CompanyInvoicesCounter> {
  //   return this.http.get<CompanyInvoicesCounter>(environment.apiFullUrl + "/SDI/UpdateCounterInvoices/" + FK_Company).toPromise();
  // }

}
